import {
  useMouseDrag
} from "./useMouseDrag.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useMouseDrag
};
//# sourceMappingURL=index.js.map
